import { useCallback } from 'react';

import { useSearchParams } from 'react-router-dom';

import { componentsRegistry } from '../../services/componentsRegistry';
import type { PortalOptions } from '../../stores/portal/PortalStore';
import { useStores } from '../../stores/useStores';

export function useOpenAuthWizard() {
  const { authStore, portalStore, wizardStore } = useStores();

  const [_, setSearchParams] = useSearchParams();

  const openAuthWizard = useCallback(
    (flowName: string, options?: PortalOptions, initialStep = 0) => {
      authStore.setIsAuthWizardOpen(true);
      wizardStore.forceStep(initialStep);

      if (!portalStore.isVisible || options?.force) {
        portalStore.openPortal(componentsRegistry.getComponent(flowName), {
          beforeClose: () => {
            authStore.setIsAuthWizardOpen(false);

            if (authStore.isDirectLanding()) {
              authStore.clearLandingKey(setSearchParams);
            }

            if (authStore.userDataReady && authStore.authStatus !== 'authenticated') {
              authStore.setAuthStatus('authenticated');
            }
          },
          ...options,
        });
      }
    },
    [authStore, portalStore, wizardStore, setSearchParams],
  );

  return { openAuthWizard };
}
